<script lang="ts">
    import { navigate } from "svelte-navigator";
    import { ALLOW_USER_ROLES } from "../evironment";
    import { getCurrentUser, isLoggedIn, sessionReady } from "../services/session";

    export let allowRoles: number[] = ALLOW_USER_ROLES;

    let allowRoute = false;

    $: onSessionReady($sessionReady);

    function onSessionReady(sessionReady: boolean): void {
        if (!sessionReady) {
            return;
        }
        checkIfAllowRoute();
    } 

    function checkIfAllowRoute(): void {

        if (!isLoggedIn()) {
            navigate('/login');
            return;
        }

        if (!allowRoles.includes(getCurrentUser().type.id)) {
            navigate('/');
            return;
        }

        allowRoute = true;
    }

</script>

{#if !$sessionReady}
Comprobando la sesión...
{:else if allowRoute}
<slot />
{/if}
